<template>
  <div>
    <a-form class="custom-nested-search-form" :form="searchForm" @submit="handleSearch">
      <a-row :gutter="24">
        <a-col :span="8" :xxl="6">
          <a-form-item label="品名">
            <a-input
              v-decorator="['item_name', {
                normalize: this.$lodash.trim
              }]"
              placeholder="请输入品名"
              allow-clear
              autocomplete="off"
            />
          </a-form-item>
        </a-col>

        <a-col :span="8" :xxl="6">
          <a-form-item>
            <a-space>
              <a-button type="primary" html-type="submit">
                搜索
              </a-button>
              <a-button @click="handleReset">
                刷新
              </a-button>
            </a-space>
          </a-form-item>
        </a-col>
      </a-row>
    </a-form>
  </div>
</template>
<script>
export default {
  name: 'SearchItem',
  data() {
    return {
      searchForm: this.$form.createForm(this, { name: 'item_search' })
    }
  },
  methods: {
    handleSearch(e) {
      e.preventDefault()
      this.$emit('submit', this.searchForm.getFieldsValue())
    },

    handleReset() {
      this.searchForm.resetFields()
      this.$emit('submit', {})
    }
  }
}
</script>
